import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=22674e42&scoped=true&"
import script from "./FooterLayout.vue?vue&type=script&lang=js&"
export * from "./FooterLayout.vue?vue&type=script&lang=js&"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&id=22674e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22674e42",
  null
  
)

export default component.exports